import { apiFetch } from "./client";

export type RuleDirection = "HIGHER_IS_BETTER" | "LOWER_IS_BETTER";

export type SettlementRule = {
  id: string;
  qualityParameterId: string;
  baseValue: number;
  /** Deducted FROM the deviation, not a threshold that releases the whole deviation. */
  tolerance: number;
  direction: RuleDirection;
  bonusPctPerPoint: number;
  penaltyPctPerPoint: number;
  minAccepted: number | null;
  maxAccepted: number | null;
};

export type SettlementRuleSet = {
  id: string;
  name: string;
  nameI18n: Record<string, string> | null;
  isDefault: boolean;
  active: boolean;
  rules: SettlementRule[];
};

export const settlementApi = {
  listSets: () => apiFetch<SettlementRuleSet[]>("/settlement/rule-sets"),
  createSet: (body: { name: string; nameI18n?: Record<string, string>; isDefault?: boolean }) =>
    apiFetch<SettlementRuleSet>("/settlement/rule-sets", { method: "POST", body }),
  updateSet: (
    id: string,
    body: { name?: string; nameI18n?: Record<string, string>; isDefault?: boolean; active?: boolean },
  ) => apiFetch<SettlementRuleSet>(`/settlement/rule-sets/${id}`, { method: "PUT", body }),
  upsertRule: (
    id: string,
    body: {
      qualityParameterId: string;
      baseValue: number;
      tolerance?: number;
      direction: RuleDirection;
      bonusPctPerPoint?: number;
      penaltyPctPerPoint?: number;
      minAccepted?: number | null;
      maxAccepted?: number | null;
    },
  ) => apiFetch<SettlementRule>(`/settlement/rule-sets/${id}/rules`, { method: "PUT", body }),
  deleteRule: (id: string, ruleId: string) =>
    apiFetch<void>(`/settlement/rule-sets/${id}/rules/${ruleId}`, { method: "DELETE" }),
};
